module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_23.8731de7b.jpg";